import { OnDestroy } from '@angular/core';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild  } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SignupService } from '../signup.service';
import { HomeService } from '../../home.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { CountryData } from '../../../../app/interfaces/country.interface';
import { NotificationService } from '../../../../app/shared/notifications/notification.service';
import { TurnstileComponent } from '../../../shared/turnstile/turnstile.component';
import { setting } from '../../../../../setting';
import { HeroVariant } from '../../hero/hero.component';

@Component({
	selector: 'agencies-form',
	templateUrl: './agencies.component.html',
	styleUrls: ['./agencies.component.scss'],
	providers: [SignupService]
})

export class AgencyComponent implements OnInit {
  @ViewChild('openModalErrorJoinUs') openModalErrorJoinUs: ElementRef;
  @ViewChild('closeButtonModalErrorSignup') closeButtonModalErrorSignup: ElementRef;
  @ViewChild(TurnstileComponent) turnstile?: TurnstileComponent;
  @Input() sharedData: any;
  @Input() clientSetting: any;
  @Input() countries!: CountryData[];
  @Input() variant: HeroVariant = 'classic';
  @Output() dataEvent = new EventEmitter<{}>();
  @Output() successEvent = new EventEmitter<void>();
  @Output() errorEvent = new EventEmitter<void>();
	public load : boolean;
	public form : FormGroup;
  public destinations: any[] = [];
  public cities: any[] = [];
 	public getClientsSettingAppAuth: any;
  public response: boolean = true;
  public buttonError: boolean = false;
  public locationAgency: any[] = [];
  public positionEnterprise: any[] = [];

  public country_id: string;
  public code_phone: any;
  public employees: (number | string)[];
  private countryName: string;
  private countrySubscription: Subscription;

  public turnstileEnabled = setting.turnstileEnabled;
  public turnstileSiteKey = setting.turnstileSiteKey;
  public turnstileToken: string | null = null;
  private turnstileResolve: ((token: string) => void) | null = null;
  private turnstileReject: ((error: unknown) => void) | null = null;

	constructor(
		  private _signupService: SignupService,
    	private fb : FormBuilder,
      private _homeService: HomeService,
      public notificationService: NotificationService
	           )

             {
              this.employees = Array.from({length: 31}, (_, i) => i);
              this.employees[30] = '+ 30';


              this.load = false;


	           }

  ngOnInit(): void {
                    this.getClientsSettingAppAuth = this.clientSetting;
                    this.initForm();
                    // this.getCountriesData();
                    this.getPositionEnterprise();
                    this.getLocationsAgency();
                   }


  initForm() {
                this.form = this.fb.group({

                    // agencia
                    Youaretype: new FormControl(1),
                    PercentageTravels: new FormControl(null, Validators.required),
                    NumberEmployee:new FormControl(null, Validators.required) ,

                    TravelAgencyName : new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(60)]) ,
                    TravelAgencyNameBusiness: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(60)]), //nuevo
                    LocationAgencyId: new FormControl(null, Validators.required), //nuevo
                    Legajo: new FormControl(null, Validators.required), //nuevo
                    TaxId: new FormControl(null, Validators.required), //nuevo
                    PhoneCode: new FormControl(null, Validators.required),
                    PhoneNumber: new FormControl(null, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]),
                    PhoneCodeWsp: new FormControl(null, Validators.required),
                    PhoneWsp: new FormControl(null, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]),
                    EmailContactAgency: new FormControl(null, [Validators.required,Validators.email]),
                    Website: new FormControl(null, [Validators.required, Validators.pattern(/^https?:\/\/[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)+.*$/)]),
                    DescriptionAgency: new FormControl(null), //nuevo
                    Contact: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(60)] ),



                    // ubicación
                    Country: new FormControl(null, Validators.required),
                    Destination: new FormControl(null, Validators.required),
                    City: new FormControl(null, Validators.required) ,
                    Adress: new FormControl(null, Validators.required),
                    ZipCode: new FormControl(null, Validators.required),

                    // comercial
                    ContactCommercial: new FormControl(null, [Validators.required]),
                    ContactCommercialLastName: new FormControl(null, [Validators.required]),
                    EmailContactCommercial: new FormControl(null, [Validators.email]),
                    PhoneCodeContactCommercial: new FormControl(null, [Validators.required]),
                    PhoneNumberContactCommercial: new FormControl(null, [Validators.required, Validators.pattern(/^[0-9]{6,}$/)]),

                    Comments: new FormControl(null, [Validators.maxLength(200)]),

                });
  }

	async onSubmit() {

    if(this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    };

    // El widget de Turnstile vive dentro de *ngIf="!load": hay que pedir el token
    // ANTES de prender `load`, o la pantalla de carga lo saca del DOM justo cuando necesita mostrarse.
    if(this.turnstileEnabled && !this.turnstileToken) {
      try {
        this.turnstileToken = await this.requestTurnstileToken();
      } catch (error) {
        this.notificationService.error('No se pudo completar la verificación de seguridad, intentá nuevamente.');
        return;
      }
    }

                this.load = true; // loading screen
                this.buttonError = false;
                this.form.value.NumberEmployee = parseInt(this.form.value.NumberEmployee);
                const city = this.cities.find(c => Number(c.city_id) === Number(this.form.value.City));
                //this.logger.log(this.form.value);
                const payload = {
                  Youaretype: 1,
                  TravelAgencyName: this.form.value.TravelAgencyName,
                  TravelAgencyNameBusiness: this.form.value.TravelAgencyNameBusiness,
                  LocationAgencyId: this.form.value.LocationAgencyId,
                  Legajo: this.form.value.Legajo,
                  EmailContact: this.form.value.EmailContactAgency,

                  TaxId: this.form.value.TaxId,
                  PhoneNumber: this.form.value.PhoneNumber,
                  PhoneCode: this.form.value.PhoneCode,
                  EmailContactAgency: this.form.value.EmailContactAgency,
                  Website: this.form.value.Website,
                  DescriptionAgency: this.form.value.DescriptionAgency,
                  NumberEmployee: this.form.value.NumberEmployee,
                  PhoneCodeWsp: this.form.value.PhoneCodeWsp,
                  PhoneWsp: this.form.value.PhoneWsp,

                  Destination: this.form.value.Destination,
                  PercentageTravels: '15',
                  Comments: this.form.value.Comments,
                  client_id: this.clientSetting.id,
                  Contact: this.form.value.Contact,

                  // ubicación
                  CodeCountry: this.country_id,
                  City: this.form.value.City,
                  Country: this.form.value.Country,
                  country_name: this.countryName,
                  city_name: city.city_name,
                  Adress: this.form.value.Adress,
                  ZipCode: this.form.value.ZipCode,
                  
                    // comercial
                  ContactCommercial: this.form.value.ContactCommercial,
                  ContactCommercialLastName: this.form.value.ContactCommercialLastName,
                  EmailContactCommercial:this.form.value.EmailContactCommercial,
                  PhoneCodeContactCommercial: this.form.value.PhoneCodeContactCommercial,
                  PhoneNumberContactCommercial: this.form.value.PhoneNumberContactCommercial,

                  turnstile_token: this.turnstileToken,

    }

		this._signupService.signup(payload).subscribe({
        next: (data: any) => {
          		this.load = false;
          		this.resetTurnstile();
          		if(data.res == 1) {
                this.resetform();
                this.successEvent.emit(); // Emitir el evento de éxito
                this.notificationService.success('Su solicitud de prerregistro fue enviada con éxito');

          		} else {

          		}
        },
        error: (error: HttpErrorResponse) => {
          this.load = false;
          this.resetTurnstile();

          // En joinus los errores del validador vienen en `men`, los del captcha en `msg`.
          const backendMsg = error.error?.msg as string | undefined;
          const backendDet = error.error?.det as string | undefined;

          if (backendMsg?.startsWith('CAPTCHA_')) {
            this.notificationService.warning(backendDet || 'Hubo un problema con la verificación de seguridad, intentá de nuevo.');
            return;
          }

          if(!this.buttonError) {
            this.buttonError = true;
            this.openModalErrorJoinUs.nativeElement.click();

            setTimeout(() => {
              this.closeButtonModalErrorSignup.nativeElement.click();
              this.errorEvent.emit();
            }, 1500);
          }
        }
      });
	}

  /** Los tokens de Turnstile son de un solo uso; hay que pedir uno nuevo tras cada intento de envío. */
  private resetTurnstile(): void {
    this.turnstileToken = null;
    this.turnstile?.reset();
  }

  /** Dispara el challenge (invisible salvo que Cloudflare necesite interacción) y espera el token. */
  private requestTurnstileToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.turnstileResolve = resolve;
      this.turnstileReject = reject;
      this.turnstile?.execute();
    });
  }

  onTurnstileVerified(token: string): void {
    this.turnstileToken = token;
    this.turnstileResolve?.(token);
    this.turnstileResolve = null;
    this.turnstileReject = null;
  }

  onTurnstileExpired(): void {
    this.turnstileToken = null;
    this.turnstileReject?.(new Error('turnstile expired'));
    this.turnstileResolve = null;
    this.turnstileReject = null;
  }

  onTurnstileError(): void {
    this.turnstileToken = null;
    this.notificationService.error('No se pudo cargar la verificación de seguridad, recargue la página.');
    this.turnstileReject?.(new Error('turnstile error'));
    this.turnstileResolve = null;
    this.turnstileReject = null;
  }

  dataForm(value: any) {
    this.dataEvent.emit(value);
  }

  dataSelectForm(value: any) {
    this.dataEvent.emit(value);
  }

	resetform(){
    this.form.reset();
	}



  getDestinations(countryId: string) {
    this.destinations = [];
    this.cities = [];
    if(countryId) {
      this.country_id = countryId;
      this.countryName = this.countries.find(c => c.country_code === (countryId).toString())?.country_name || '';
      this.countrySubscription = this._homeService.getDestinationsData(countryId).subscribe({
        next: (res: any) => {
          this.destinations = res;
        },
        error: (error: HttpErrorResponse) => {
          console.error(error);
        }
      });

    }
  }

  getCities(destinationId: string) {
    this.countrySubscription = this._homeService.getCitiesData(destinationId).subscribe({
      next: (res: any) => {
        this.cities = res;
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
      }
    });
  }

  countryId(countryName: any) {
    this.country_id = this.countries.find(c => c.country_name === countryName)?.country_code || '';
    this.country_id = this.country_id;
  }

  codePhone(code_phone: any) {
    this.code_phone = code_phone;
  }

  webDetectError(input: any) {

    const webRegex = /(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w-._~:/?#[\]@!$&'()*+,;=.]+/;

    const webValue = input.target.value;

    const isValidWeb = webRegex.test(webValue);

    if(!isValidWeb) {

      this.form.get('Website').setErrors({'errorWebsiteFormat': true});
    } else {

      this.form.get('Website').setErrors(null);
    }
  }

  emailInput(input: any) {
    // Expresión regular para validar el formato del correo electrónico
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Obtener el valor del correo electrónico del evento
    const emailValue = input.target.value;

    // Validar el formato del correo electrónico usando la expresión regular
    const isValidEmail = emailRegex.test(emailValue);

    // Si el correo electrónico no cumple con el formato deseado
    if (!isValidEmail) {
      // Establecer el error en el control del formulario
      this.form.get('EmailContact').setErrors({ 'errorEmailFormat': true });
    } else {
      // Si el correo electrónico cumple con el formato, eliminar cualquier error existente
      this.form.get('EmailContact').setErrors(null);
    }
   }

   getLocationsAgency(): void {
    this._homeService.getLocationAgency().subscribe({
      next: (res: any) => {
        if(res && res.length > 0) {
          this.locationAgency = res;
        }
      },
      error: (error: HttpErrorResponse) => {
      }
    })
   }

   getPositionEnterprise(): void {
    this._homeService.getPositionAgency().subscribe({
      next: (res: any) => {
        if(res && res.length > 0) {
          this.positionEnterprise = res;
        }
      },
      error: (error: HttpErrorResponse) => {
      }
    })
   }

        /**
   * Bloquea la entrada de caracteres no deseados (`e`, `E`, `+`, `-`) en campos numéricos.
   * @param event El evento de teclado.
   */
blockInvalidKeys(event: KeyboardEvent, input?: string) {
  const key = event.key;

  switch (input) {
      case 'name':
         const inputElementName = event.target as HTMLInputElement;
          const currentValueName = inputElementName.value || '';
          const selectionStartName = inputElementName.selectionStart ?? 0;

          // Permitir teclas de control
          if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
              'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) {
              return;
          }

          // Validar espacio
          if (key === ' ') {
              if (selectionStartName === 0) {
                  event.preventDefault();
                  return;
              }
              if (selectionStartName > 0 &&
                  currentValueName.charAt(selectionStartName - 1) === ' ') {
                  event.preventDefault();
                  return;
              }
              return;
          }

          // Solo letras (con acentos y ñ)
          if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1]$/.test(key)) {
              event.preventDefault();
          }
          break;

      case 'number':
          if (['e', 'E', '+', '-', ',', '.'].includes(key)) {
              event.preventDefault();
            }
          break;
  }
}

}
